<style scoped>
.line-ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>

<template>
    <div>
        <page-title>定时任务</page-title>
        <page-body>
            <list-header>
                <div flex="dir:left box:last cross:center">
                    <div>
                        <!--<el-button @click="updateTaskId(1743)">update task_id</el-button>-->
                    </div>
                    <div>
                        <el-form :inline="true" onsubmit="return false">
                            <el-form-item style="margin-bottom: 0;">
                                <el-radio-group size="mini" v-model="type" @change="typeChange">
                                    <el-radio-button label="/dashboard/admin/task/fail">失败记录</el-radio-button>
                                    <el-radio-button label="/dashboard/admin/task/index">创建记录</el-radio-button>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item style="margin-bottom: 0;">
                                <el-checkbox v-model="removeSameHost">站点去重</el-checkbox>
                            </el-form-item>
                            <el-form-item style="margin-bottom: 0;">
                                <el-date-picker
                                        style="width: 210px"
                                        size="mini"
                                        v-model="dateScope"
                                        type="daterange"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item style="margin-bottom: 0">
                                <el-select v-model="keyword" placeholder="常用条件" size="mini" @change="defaultKeysChange">
                                    <el-option
                                            v-for="item in defaultKeys"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item style="margin-bottom: 0; max-width: 150px">
                                <el-input v-model="keyword"
                                          @keyup.enter.native="search()"
                                          size="mini"
                                          placeholder="网址/信息"
                                          suffix-icon="el-icon-search"/>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </list-header>
            <el-table v-loading="loading" :data="list" style="width: 100%" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column label="任务信息">
                    <template slot-scope="scope">
                        <div flex>
                            <div>时间:&nbsp;</div>
                            <div>{{scope.row.add_time}}</div>
                            <div style="padding: 0 20px;font-size: 7px">|</div>
                            <div>异常:&nbsp;</div>
                            <div>{{scope.row.exception}}</div>
                            <div style="padding: 0 20px;font-size: 7px">|</div>
                            <div>状态码:&nbsp;</div>
                            <div>{{scope.row.status_code}}</div>
                        </div>
                        <div flex="box:first">
                            <div>站点:&nbsp;</div>
                            <div v-if="scope.row.task">
                                <span>{{scope.row.task.host.name}}</span>
                                <span style="color: #909399; margin-left: 10px">{{scope.row.task.host.domain}}</span>
                            </div>
                            <div v-else>-</div>
                        </div>
                        <div flex="box:first">
                            <div>网址:&nbsp;</div>
                            <div>
                                <div class="line-ellipsis">{{scope.row.url}}</div>
                            </div>
                        </div>
                        <div flex="box:first">
                            <div>信息:&nbsp;</div>
                            <div>{{scope.row.msg}}</div>
                        </div>
                        <div flex="box:first">
                            <div>详情:&nbsp;</div>
                            <div>
                                <el-button type="text" @click="showData(scope.row)" style="padding: 0">查看</el-button>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="150" label="操作">
                    <template slot-scope="scope">
                        <el-button :disabled="scope.row.disabled?true:false" type="text" @click="executeRow(scope.row)">
                            执行
                        </el-button>
                        <span>|</span>
                        <el-button :disabled="scope.row.disabled?true:false" type="text" @click="deleteRow(scope.row)">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div flex="box:last cross:center">
                <div>
                    <el-button type="primary" plain size="mini" @click="executeSelected">批量执行已选</el-button>
                    <el-button type="primary" plain size="mini" @click="runningListVisible = true">查看运行队列</el-button>
                </div>
                <div>
                    <el-pagination
                            style="margin: 20px -5px;padding: 0; text-align: right"
                            background
                            layout="prev, pager, next"
                            @current-change="pageChange"
                            :total="parseInt(pagination && pagination.totalCount ? pagination.totalCount : 0)">
                    </el-pagination>
                </div>
            </div>
        </page-body>

        <el-dialog title="详细信息" :visible.sync="showDetailData" width="75%">
            <template v-if="detail">
                <div style="margin: 10px 0" flex>
                    <div>时间:&nbsp;</div>
                    <div>{{detail.add_time}}</div>
                    <div style="padding: 0 20px;font-size: 7px">|</div>
                    <div>异常:&nbsp;</div>
                    <div>{{detail.exception}}</div>
                    <div style="padding: 0 20px;font-size: 7px">|</div>
                    <div>状态码:&nbsp;</div>
                    <div>{{detail.status_code}}</div>
                </div>
                <div style="margin: 10px 0" flex="box:first">
                    <div>站点:&nbsp;</div>
                    <div v-if="detail.task">
                        <span>{{detail.task.host.name}}</span>
                        <span style="color: #909399; margin-left: 10px">{{detail.task.host.domain}}</span>
                    </div>
                    <div v-else></div>
                </div>
                <div style="margin: 10px 0" flex="box:first">
                    <div>网址:&nbsp;</div>
                    <div>
                        <div>{{detail.url}}</div>
                    </div>
                </div>
                <div style="margin: 10px 0" flex="box:first">
                    <div>信息:&nbsp;</div>
                    <div>{{detail.msg}}</div>
                </div>
                <div style="margin: 10px 0" flex="box:first">
                    <div>详情:&nbsp;</div>
                    <div>
                        <textarea
                                style="width: 100%;padding: 0;margin: 0;border: none;resize: vertical;min-height: 200px"
                                v-model="detail.data"></textarea>
                    </div>
                </div>
            </template>
        </el-dialog>

        <el-dialog title="运行任务列表" :visible.sync="runningListVisible" fullscreen>
            <el-table :data="runningList" style="width: 100%">
                <el-table-column label="任务">
                    <template slot-scope="scope">
                        <div style="width: 100%" flex="box:first">
                            <div style="width: 60px">URL:</div>
                            <div>{{scope.row.url}}</div>
                        </div>
                        <div style="width: 100%" flex="box:first">
                            <div style="width: 60px">HOST:</div>
                            <div>{{scope.row.host.name}}, {{scope.row.host.domain}}</div>
                        </div>
                        <div style="width: 100%" flex="box:first">
                            <div style="width: 60px">MSG:</div>
                            <div>{{scope.row.msg?scope.row.msg:'-'}}</div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="100" label="状态">
                    <template slot-scope="scope">{{scope.row.running?'运行中':'已运行'}}</template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
import axios from '@/axios'
import helper from '@/helper'

export default {
    data() {
        const defaultKeys = [
            {
                label: '',
                value: ''
            },
            {
                label: '同一服务器多套域名错误',
                value: '没有找到token'
            },
            {
                label: 'HTTPS证书错误',
                value: 'cURL error 51||cURL error 35'
            },
            {
                label: '服务器错误，需调试',
                value: '404 Not Found'
            },
            {
                label: '请求超时，尝试重试',
                value: 'cURL error 28'
            }
        ]
        return {
            defaultKeys: defaultKeys,
            loading: false,
            list: null,
            pagination: null,
            is_pass: null,
            dateScope: '',
            keyword: '',
            removeSameHost: false,
            type: '/dashboard/admin/task/fail',
            showDetailData: false,
            detail: null,
            selectedList: [],
            runningList: [],
            runningListVisible: false
        }
    },
    created() {
        this.loadData(0)
    },
    methods: {
        loadData(page) {
            this.getList(page).then(e => {
                for (let i in e.list) {
                    e.list[i].disabled = false
                }
                this.list = e.list
                this.pagination = e.pagination
            })
        },
        getList(page) {
            return new Promise(resolve => {
                this.loading = true
                let startDate = null
                let endDate = null
                if (this.dateScope) {
                    startDate = helper.dateFormat('yyyy-M-d', this.dateScope[0])
                    endDate = helper.dateFormat('yyyy-M-d', this.dateScope[1])
                }
                axios({
                    url: 'admin/task/fail',
                    params: {
                        page: page,
                        keyword: this.keyword,
                        type: this.type,
                        start_date: startDate,
                        end_date: endDate,
                        remove_same_host: this.removeSameHost
                    }
                }).then(e => {
                    this.loading = false
                    if (e.data.code === 0) {
                        resolve(e.data.data)
                    } else {
                        this.$message.error(e.data.msg)
                    }
                })
            })
        },
        defaultKeysChange(e) {
            this.search()
        },
        search() {
            this.loadData(0)
        },
        pageChange(page) {
            this.loadData(page - 1)
        },
        typeChange(e) {
            this.$router.push(e)
        },
        showData(row) {
            this.detail = row
            this.showDetailData = true
        },
        deleteRow(row) {
            this.$confirm('确认删除？', '提示', {
                type: 'warning'
            }).then(e => {
                row.disabled = true
                axios({
                    url: 'admin/task/delete',
                    params: {
                        id: row.id
                    }
                }).then(e => {
                    if (e.data.code === 0) {
                        this.$message.success(e.data.msg)
                    } else {
                        row.disabled = false
                        this.$message.error(e.data.msg)
                    }
                }).catch(e => {
                })
            }).catch(e => {
            })
        },
        executeRow(row) {
            this.$confirm('确认执行？', '提示', {
                type: 'warning'
            }).then(e => {
                row.disabled = true
                axios({
                    url: 'admin/task/execute',
                    params: {
                        id: row.id
                    }
                }).then(e => {
                    if (e.data.code === 0) {
                        this.$message.success(e.data.msg)
                    } else {
                        row.disabled = false
                        this.$message.error(e.data.msg)
                    }
                }).catch(e => {
                })
            }).catch(e => {
            })
        },
        handleSelectionChange(list) {
            this.selectedList = list
        },
        executeSelected() {
            if (!this.selectedList.length) {
                this.$message.error('请先勾选任务。')
                return
            }
            const runList = (index) => {
                index = index || 0
                return new Promise(resolve => {
                    this.selectedList[index].disabled = true
                    const runningItem = {
                        host: this.selectedList[index].task.host,
                        url: this.selectedList[index].url,
                        running: true,
                        msg: ''
                    }
                    this.runningList.push(runningItem)
                    axios({
                        url: 'admin/task/execute',
                        params: {
                            id: this.selectedList[index].id
                        }
                    }).then(e => {
                        this.runningList[index].running = false
                        this.runningList[index].msg = e.data.msg
                        if (e.data.code !== 0) {
                            this.selectedList[index].disabled = false
                        }
                        if (this.selectedList[index + 1]) {
                            runList(index + 1)
                        } else {
                            resolve()
                        }
                    }).catch(e => {
                    })
                })
            }

            this.$confirm('确认执行已选的任务？', '提示').then(e => {
                this.runningList = []
                this.runningListVisible = true
                runList()
            }).catch(e => {
            })
        },
        updateTaskId(start) {
            start = start || 1
            axios({
                url: 'test/update-tr',
                params: {
                    start: start
                }
            }).then(e => {
                if (e.data.code === 0) {
                    this.updateTaskId(start + 1)
                } else {
                    this.$alert('OK:' + start, 'ok')
                }
            }).catch(e => {
            })
        }
    }
}
</script>
